export const USER_TYPE_SELECTION_CONSTANTS = {
  WELCOME_TO: 'Welcome to',
  I_AM_A_FAN: 'I AM A FAN',
  I_AM_A_CREATOR: 'I AM A CREATOR'
};
